import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { expandProperty } from 'inline-style-expand-shorthand'; // https://jsperf.com/array-indexof-vs-object-key-lookup2/12

var handledCssProps = {
  // 'font', Oops, is not supported by inline-style-expand-shorthand
  padding: true,
  margin: true,
  border: true,
  borderWidth: true,
  borderStyle: true,
  borderColor: true,
  borderTop: true,
  borderRight: true,
  borderBottom: true,
  borderLeft: true,
  borderRadius: true,
  background: true,
  outline: true
};
export default (function () {
  var expandCssShorthands = function expandCssShorthands(styles) {
    return Object.keys(styles).reduce(function (acc, cssPropertyName) {
      var cssPropertyValue = styles[cssPropertyName];

      if (cssPropertyValue === null || typeof cssPropertyValue === 'undefined') {
        return Object.assign({}, acc, _defineProperty({}, cssPropertyName, cssPropertyValue));
      }

      if (handledCssProps[cssPropertyName]) {
        var expandedProps = expandProperty(cssPropertyName, cssPropertyValue);

        if (expandedProps) {
          return Object.assign({}, acc, {}, expandedProps);
        }
      }

      if (Array.isArray(cssPropertyValue)) {
        return Object.assign({}, acc, _defineProperty({}, cssPropertyName, cssPropertyValue));
      }

      if (_typeof(cssPropertyValue) === 'object') {
        return Object.assign({}, acc, _defineProperty({}, cssPropertyName, expandCssShorthands(cssPropertyValue)));
      }

      return Object.assign({}, acc, _defineProperty({}, cssPropertyName, cssPropertyValue));
    }, {});
  };

  return expandCssShorthands;
});